import React from 'react';
import { Field, Modal, Spinner } from '../../components/ui';
import { GUEST_TYPES } from './useCards';

// Desktop Cards — the printable sheet of card names (one per family / firm).
export default function CardsDesktop({ vm }) {
  const {
    canView, canEdit, cards, counts, loading, functions, fnFilter, setFnFilter,
    typeFilter, setTypeFilter, q, setQ, editing, setEditing, cardForm, setCardF, saveCard, saving,
    openCard, print, event,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Cards</h1></div>
        <div className="card card-pad empty">You do not have access to the guest list of this event.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head no-print">
        <h1>Cards</h1>
        <span className="muted">{counts.cards} cards · {counts.family} families · {counts.business} business</span>
        <div className="spacer" />
        <select value={fnFilter} onChange={e => setFnFilter(e.target.value)} title="Filter by function"
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, maxWidth: 220 }}>
          <option value="">All functions</option>
          {functions.map(f => <option key={f.FunctionId} value={f.FunctionId}>{f.FunctionName}</option>)}
        </select>
        <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} title="Family or business"
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10 }}>
          <option value="">All</option>
          {GUEST_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
        <input placeholder="Search…" value={q} onChange={e => setQ(e.target.value)}
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, maxWidth: 180 }} />
        <button className="btn primary" onClick={print}>🖨 Print</button>
      </div>

      <div className="print-title" style={{ display: 'none' }}>{event?.EventName}</div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : cards.length === 0 ? <div className="card card-pad empty">No guests match.</div> : (
          <div className="card-sheet">
            {cards.map((c, i) => (
              <div key={c.key} className="guest-card" onClick={() => canEdit && openCard(c)} title={canEdit ? 'Edit the card text' : undefined}>
                <div className="guest-card-no">{i + 1}</div>
                <div className="guest-card-name">{c.name}</div>
                {c.subtitle && <div className="guest-card-sub">{c.subtitle}</div>}
                <div className="guest-card-meta">
                  {c.mobile}{c.city ? ` · ${c.city}` : ''}{c.persons > 1 ? ` · ${c.persons} persons` : ''}
                </div>
                {c.functions.length > 0 && <div className="guest-card-fns">{c.functions.join(' · ')}</div>}
              </div>
            ))}
          </div>
        )}

      {editing && (
        <Modal
          title={`Card · ${editing.name}`}
          onClose={() => setEditing(null)}
          footer={<>
            <button className="btn light" onClick={() => setEditing(null)}>Cancel</button>
            <button className="btn primary" disabled={saving} onClick={saveCard}>{saving ? 'Saving…' : 'Save'}</button>
          </>}
        >
          <div className="form-grid">
            <Field label="Card type" type="select" value={cardForm.GuestType} options={GUEST_TYPES} onChange={(v) => setCardF('GuestType', v)} />
            {cardForm.GuestType === 'Business' && (
              <Field label="Company name" value={cardForm.CompanyName} onChange={(v) => setCardF('CompanyName', v)} />
            )}
            <div style={{ gridColumn: '1 / -1' }}>
              <Field label="Name on the card (leave blank to use the guest's name)" value={cardForm.CardName}
                onChange={(v) => setCardF('CardName', v)} placeholder="e.g. Shri & Smt. Haresh Abichandani" />
            </div>
          </div>
          <div className="muted" style={{ fontSize: 12 }}>
            Applies to every member of this family, so one card is printed for the household.
          </div>
        </Modal>
      )}
    </div>
  );
}
